import { Instance, SnapshotIn, types, applySnapshot } from 'mobx-state-tree';

import { DeviceData } from '../domain/Device';

export const ProcedureDeviceInferred = types.model({
    deviceId: types.maybeNull(types.string),
    device: types.maybeNull(types.string),
    exist: types.maybeNull(types.boolean),
    platform: types.maybeNull(types.string),
    procedureName: types.maybeNull(types.string),
    procedureDescription: types.maybeNull(types.string),
    token: types.maybeNull(types.string),
    procedureVersionId: types.maybeNull(types.string),
    hasScoreData: types.maybeNull(types.boolean),
    environments: types.optional(types.array(types.string), []),
})
    .actions(self => {
        const updateDevice = (data: DeviceData) => applySnapshot(self, data);

        return {
            updateDevice,
        }
    });

type ProcedureDeviceFactoryType = typeof ProcedureDeviceInferred;
interface IProcedureDeviceFactory extends ProcedureDeviceFactoryType { };
export const ProcedureDevice: IProcedureDeviceFactory = ProcedureDeviceInferred;
export interface IProcedureDevice extends Instance<IProcedureDeviceFactory> { };
export interface IProcedureDeviceSnapshotIn extends SnapshotIn<IProcedureDevice> { };
